import AppHeader from '../app/appHeader';
import React, { useEffect, useState } from 'react';
import './styles/pendingRegistration.scss';
import { Link, Typography, Dialog, Button } from '@getgo/chameleon-web/react';
import Footer from '../footer/footer';
import { useTranslation } from 'react-i18next';
import { useEventContext } from '../context/eventContext';
import { useParams } from 'react-router';
import { IEventUrlParameters } from '../event/eventInterface';
import API from '../utils/api';
import FullScreenLoader from '../utils/fullScreenLoader/FullScreenLoader';
import MailToUtils from '../../utils/MailToUtils';
import { useHistory } from 'react-router-dom';
import { apiStatus } from '../../utils/constants';

const PendingRegistration = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setLoading] = useState<boolean>(true);
  const { eventId, eventRegistrationId } = useParams<IEventUrlParameters>();
  const { setEventDetails, eventDetails } = useEventContext();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (!eventDetails) {
      const getEvent = async () => {
        const eventData = await API.getEventDetails(eventId || '');
        const lang = eventData?.data?.locale?.split('_')[0]?.toLowerCase() || 'en';
        if (lang !== i18n.language) {
          i18n.changeLanguage(lang, () => {
            // TO-DO Change language for date
            document.documentElement.lang = lang === 'zh' ? 'zh-cn' : lang;
          });
        }
        if (eventData.status === apiStatus.success) {
          setEventDetails(eventData.data);
        }
      };
      getEvent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventDetails]);

  useEffect(() => {
    if (eventDetails?.locale.includes(i18n.language)) {
      setLoading(false);
    }
  }, [eventDetails?.locale, i18n.language]);

  return isLoading ? (
    <FullScreenLoader />
  ) : (
    <div className="pending-registration-grid">
      <AppHeader />
      <div className="pending-registration">
        <div className="box">
          <div className="box-space">
            <div>
              <Typography color="text-01" variant="heading-large">
                {t('pendingApproval.title')}
              </Typography>
            </div>
            <div className="pending-registration-description">
              <p>
                <Typography color="text-01" variant="body-large">
                  {t('pendingApproval.description')}
                </Typography>
              </p>
              <p>
                <Typography color="text-01" variant="body-large">
                  {t('pendingApproval.contactOrganizer')}
                  <Link href={MailToUtils.createLink(eventDetails?.organizers?.[0]?.email ?? '')}>
                    {eventDetails && eventDetails.organizers[0]?.email}
                  </Link>
                </Typography>
              </p>
              <p>
                <Typography color="text-01" variant="body-large">
                  {t('pendingApproval.cantMake')}
                  <Link onClick={() => setIsDialogOpen(true)}>
                    {t('pendingApproval.cancelRegistration')}
                  </Link>
                </Typography>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Dialog
        open={isDialogOpen}
        title={t('cancelRegistration.confirmationTitle')}
        size="xlarge"
        actions={
          <>
            <Button onClick={(e) => setIsDialogOpen(false)} variant="secondary">
              {t('cancelRegistration.confirmationCanceltext')}
            </Button>
            <Button
              onClick={(e) => {
                setIsDialogOpen(false);
                history.push(`/cancelregistration/${eventId}/${eventRegistrationId}`);
              }}
            >
              {t('cancelRegistration.confirmationOktext')}
            </Button>
          </>
        }
      >
        {t('cancelRegistration.confirmationBodyText')}
      </Dialog>
    </div>
  );
};

export default PendingRegistration;
